import React, { useState, useEffect } from 'react';
import '../styles/Contact.css';

const Contact: React.FC = () => {
  const [typedText, setTypedText] = useState('');
  const fullText = `Hello! Thanks for visiting my portfolio.

> Reach out via email for any collaboration ideas / questions.
> Checkout my GitHub to see the latest projects I have been working on!
> Feel free to connect on LinkedIn!

I'm currently available for work and looking for new opportunities.
Looking forward to connecting with you!`;

  useEffect(() => {
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setTypedText(fullText.substring(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, 20);

    return () => clearInterval(typingInterval);
  }, [fullText]);

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-description">
          Want to get in touch?
          I'm always open to new opportunities and collaborations.
        </p>

        <div className="contact-content-split">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-icon">
                <i className="location-icon">📍</i>
              </div>
              <div className="contact-details">
                <h3>Location</h3>
                <p>Australia</p>
              </div>
            </div>
            
            <div className="contact-card">
              <div className="contact-icon">
                <i className="email-icon">✉️</i>
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <p>contact@ryankennedy.au</p>
              </div>
            </div>
            
            <div className="social-links">
              <a href="https://github.com/RY4NSK" target="_blank" rel="noopener noreferrer" className="social-link">
                GitHub
              </a>
              <a href="https://www.linkedin.com/in/ryankennedysec/" target="_blank" rel="noopener noreferrer" className="social-link">
                LinkedIn
              </a>
            </div>
          </div>
          
          <div className="terminal-container">
            <div className="terminal-contact-card">
              <div className="terminal-header">
                <div className="terminal-buttons">
                  <span className="terminal-button red"></span>
                  <span className="terminal-button yellow"></span>
                  <span className="terminal-button green"></span>
                </div>
                <span className="terminal-title">contact.sh</span>
              </div>
              <div className="terminal-body">
                <pre className="terminal-text">{typedText}<span className="terminal-cursor"></span></pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact; 